import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { storyblokEditable } from "@cinch-nx/data-storyblok";
import { useEffect } from "react";
import { Heading, Text } from "../shared";
import styles from "./generic-teaser.module.css";
export var GenericTeaser = function(blok) {
    var title = blok.title, body = blok.body;
    useEffect(function() {
        if (title === "test") {
            throw new Error("hell now");
        }
    }, [
        title
    ]);
    return /*#__PURE__*/ _jsxs("div", _object_spread_props(_object_spread({}, storyblokEditable(blok)), {
        children: [
            /*#__PURE__*/ _jsx(Heading, {
                className: styles.heading,
                children: title
            }),
            /*#__PURE__*/ _jsx(Text, {
                children: body
            })
        ]
    }));
};
